import React from 'react';
import {Tooltip} from '@material-ui/core';
import {IPropsView} from '../Config/ToolTip.types';
import { makeStyles } from '@material-ui/core/styles';
import '../Style/ToolTip.css';

const useStyles = makeStyles(() => ({
    customTooltip: {
        backgroundColor: '#002D70;',
        padding: '8px'
    },
    customArrow: {
        color: '#002D70;'
    },
    preEvaluationTooltip: {
        backgroundColor: '#111827',
        padding: '4px 8px'
    },
    preEvaluationArrow: {
        color: '#111827'
    }
}));

export default function ArrowTooltips({title, placement, children, designedTooltip = ''}:IPropsView) {
    const classes = useStyles();

    return (
        <Tooltip
            title={title}
            placement={placement}
            classes={{
                tooltip: designedTooltip ? classes[`${designedTooltip}Tooltip`] : classes.customTooltip,
                arrow: designedTooltip ? classes[`${designedTooltip}Arrow`] : classes.customArrow
            }}
            arrow>
            {children && children}
        </Tooltip>
    );
}
